(($) => {
    "use strict";

    if (!$('.acf-blocks-blog-header-category-links').length) {
        return;
    }
    console.log("acf-blocks/blog-header-category-links scripts loaded...");

    $('.btn-search-category-bar').on('click', () => {
        $(".search-overlay input#filterInput").val('blog-posts');
        $(".search-overlay").addClass("active");
    });

})(jQuery);